import { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import { isAndroid } from '../utils/helpers/common';
import { ROUTES_TO_HIDE_TAB_BAR_ON_KEYBOARD_OPEN } from '../utils/helpers/constants';

const THRESHOLD = 50;

export const useHideTabBarOnKeyboardOpen = () => {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
  const router = useRouter();
  const isAndroidDevice = isAndroid();
  const initialHeightRef = useRef<number | null>(null);

  const isAllowedPage = ROUTES_TO_HIDE_TAB_BAR_ON_KEYBOARD_OPEN.includes(
    router.pathname
  );

  useEffect(() => {
    if (!isAndroidDevice || !isAllowedPage) return;

    if (!initialHeightRef.current) {
      initialHeightRef.current =
        window.visualViewport?.height || window.innerHeight;
    }

    const handleResize = () => {
      const currentHeight = window.visualViewport?.height || window.innerHeight;
      const heightDiff =
        (initialHeightRef.current || currentHeight) - currentHeight;

      setIsKeyboardOpen(heightDiff > THRESHOLD);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [isAndroidDevice, isAllowedPage]);

  return isAndroidDevice && isAllowedPage && isKeyboardOpen;
};
